import { usePrivileges } from '@/hooks/usePrivilleges';
import { IColumns, useI18n } from '@group-link-one/grouplink-components';
import { useEffect, useMemo } from 'react';

export const useTrackColumns = () => {
  const { t } = useI18n();
  const { features } = usePrivileges();

  const columns: IColumns[] = useMemo(() => {
    const columns = [
      {
        columnName: t('userEvents.table.columns.event_time'),
        hasActions: false,
      },
      {
        columnName: t('userEvents.table.columns.adv_id'),
        hasActions: false,
      },
    ];

    if (features.show_user_events_details_btn) {
      columns.push({
        columnName: t('userEvents.table.columns.actions'),
        hasActions: false,
      });
    }

    return columns;
  }, [features.show_user_events_details_btn]);

  return {
    columns,
  };
};
